import { ErrorObject } from '../StoreConstants';

export interface UserPropType {
    authenticated: boolean;
    token: string;
    userRole: number;

}

export interface SigninInitialState {
    user: UserPropType;
}

export default {
    user: {
        authenticated: false,
        token: '',
        userRole: 0
    }
} as SigninInitialState;